import React from "react";

// Pagination bar: "Menampilkan 1–20 dari 137 baris" + nomor halaman.
// Halaman jauh dari halaman aktif diringkas jadi "…".
const Pagination = ({
  page,
  totalCount,
  pageSize,
  onPageChange,
  label = "baris",
}) => {
  if (!totalCount) return null;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  if (totalPages <= 1) return null;

  const pages = [];
  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || Math.abs(p - page) <= 2) pages.push(p);
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <small className="text-muted">
        Menampilkan {Math.min((page - 1) * pageSize + 1, totalCount)}–
        {Math.min(page * pageSize, totalCount)} dari {totalCount} {label}
      </small>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(page - 1)}>
              ‹
            </button>
          </li>
          {pages.map((p, idx, arr) => (
            <React.Fragment key={p}>
              {idx > 0 && arr[idx - 1] !== p - 1 && (
                <li className="page-item disabled">
                  <span className="page-link">…</span>
                </li>
              )}
              <li className={`page-item ${p === page ? "active" : ""}`}>
                <button className="page-link" onClick={() => onPageChange(p)}>
                  {p}
                </button>
              </li>
            </React.Fragment>
          ))}
          <li className={`page-item ${page >= totalPages ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(page + 1)}>
              ›
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
